import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  root: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
  },
})

const TransitionPage = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
)

TransitionPage.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object,
}

export default withStyles(styles)(TransitionPage)



// WEBPACK FOOTER //
// ./src/containers/TransitionPage.js